import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class PiratesHideout9PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.PIRATES_HIDEOUT9;
}

export default PiratesHideout9PoiTileEntity;
